import React from 'react';
import { H2 } from '@osmosis/react-ui/components/Text';
import { TextProps } from '@osmosis/react-ui/components/Text';
import { getTextColor } from '../../../lib/composer/schemas/theme';

type Props = {
  text: string;
  theme?: string;
  textProps?: TextProps;
};

/** Render a generic title. */
const Title = (props: Props) => {
  const { theme = 'transparent', text, textProps = {} } = props;

  const textColor = getTextColor(theme);

  return (
    <H2 color={textColor} {...textProps}>
      {text}
    </H2>
  );
};

export default Title;
